import React, { FC, ReactElement } from 'react';
import AppCard from '../../Components/ui/card/AppCard';
import AppBaseForm from '../../Components/ui/form/AppBaseForm';
import {
  AppAutocompleteInput,
  AppDateTimeInput,
  AppSelectInput,
  AppTextInput,
} from '../../Components/ui/input';
import { REVIEW_RATING_CHOICES } from './constants';

const ReviewDetails: FC<any> = (props): ReactElement => {
  return (
    <AppBaseForm {...props} disabledCards={props.mode === 'show'}>
      <AppCard expanded title="Recensione">
        <AppTextInput source="id" label="ID" disabled md={3} />
        <AppDateTimeInput source="createdAt" label="Data creazione" disabled md={3} />
        <AppDateTimeInput source="updatedAt" label="Ultimo aggiornamento" disabled md={3} />
        <AppSelectInput
          source="rating"
          choices={REVIEW_RATING_CHOICES}
          label="Valutazione"
          md={3}
        />
        <AppTextInput source="content" label="Contenuto" multiline md={12} />

        <AppAutocompleteInput
          disabled
          label="Autore"
          source="item.saleExperiments[0].participations[0].fkPresenter"
          resettable
          reference="participants"
          optionText={(p) => {
            if (!p) return '';
            if (p.type === 'company') return p.businessName;
            return `${p.firstName} ${p.lastName}`;
          }}
          md={4}
        />
        <AppAutocompleteInput
          disabled
          label="Destinatario"
          source="recipientId"
          resettable
          reference="people"
          optionText={(p) => {
            if (!p) return '';
            if (p.type === 'company') return p.businessName;
            return `${p.firstName} ${p.lastName}`;
          }}
          md={4}
        />
        <AppAutocompleteInput
          disabled
          label="Lotto"
          source="itemId"
          resettable
          reference="items"
          optionText="title"
          md={4}
        />
      </AppCard>
    </AppBaseForm>
  );
};

export default ReviewDetails;
